var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGivenchy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 42,
    viewBox: "0 0 41 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.0312 42H22.2042V30.7814H32.2298V34.5207H26.105V38.2604H36.1305V27.0418H22.2042V23.3015H40.0312V42ZM0 42H17.8093V30.7814H7.8015V34.5207H13.9086V38.2604H3.90075V27.0418H17.8093V23.3015H0V42ZM40.0312 0H22.2042V11.2186H32.2298V7.47961H26.105V3.73964H36.1305V14.9582H22.2042V18.6979H40.0312V0ZM0 0H17.8093V11.2186H7.8015V7.47961H13.9086V3.73964H3.90075V14.9582H17.8093V18.6979H0V0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGivenchy);
export default __webpack_public_path__ + "static/media/givenchy.85c54857aef93d6a142a0082527cb612.svg";
export { ForwardRef as ReactComponent };